export default class {
  constructor(el) {
    const fullDocumentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
    )

    el.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    })

    function setOpacity() {
      window.requestAnimationFrame(() => {
        el.parentNode.style.opacity = Math.min(
          0.9,
          (window.scrollY - fullDocumentHeight / 1.5) / 200,
        )
      })
    }

    el.addEventListener("mouseenter", () => {
      el.parentNode.style.opacity = 1
    })

    el.addEventListener("mouseleave", setOpacity)

    window.addEventListener("scroll", setOpacity, {
      passive: true,
    })

    setOpacity()
  }
}
